import type Controller from '@ember/controller';
import Route from '@ember/routing/route';
import type PublicTransition from '@ember/routing/transition';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';

export default class RoutinesRoute extends Route {
	@service('ai-chat') declare aiChatService: Service.AIChat;

	override async beforeModel(transition: PublicTransition): Promise<void> {
		document.body.id = 'page-genie-routines';

		await this.aiChatService.ensureAvailable(transition);

		this.aiChatService.redirectIfFeatureGated(BillingFeature.AI_ROUTINES);
	}

	override resetController(_controller: Controller, isExiting: boolean): void {
		// Only the routines routes write the routine id, so leaving the tree entirely must clear it. Without
		// this it lingers, and because `activatedRoute` flips in routeWillChange — before setupController runs
		// — re-entering routines from elsewhere would briefly report the PREVIOUS routine and highlight the
		// wrong row. Mirrors genie.ts. Moving between index / detail / run keeps this parent mounted, which is
		// what the activeRoutineId route gate handles instead.
		if (isExiting) {
			this.aiChatService.applyUrlRoutine(null);
		}
	}
}
